// Mock data for Vintive Studio website

export const heroImages = [
  'https://images.unsplash.com/photo-1554941829-202a0b2403b8',
  'https://images.unsplash.com/photo-1640043887726-d13734ce7570',
  'https://images.unsplash.com/photo-1646809669486-10fea26c5f28'
];

export const clients = [
  { name: 'Client 1', logo: 'C1' },
  { name: 'Client 2', logo: 'C2' },
  { name: 'Client 3', logo: 'C3' },
  { name: 'Client 4', logo: 'C4' },
  { name: 'Client 5', logo: 'C5' },
  { name: 'Client 6', logo: 'C6' }
];

export const services = [
  {
    id: 1,
    title: 'Filmmaking',
    description: 'Cinematic storytelling that captures your brand essence',
    icon: 'Video'
  },
  {
    id: 2,
    title: 'Video Editing',
    description: 'Professional post-production that brings your vision to life',
    icon: 'Film'
  },
  {
    id: 3,
    title: 'Motion Graphics',
    description: 'Dynamic animations that engage and inspire',
    icon: 'Layers'
  },
  {
    id: 4,
    title: 'Graphic Design',
    description: 'Visual designs that communicate and convert',
    icon: 'Palette'
  },
  {
    id: 5,
    title: 'Logo & Branding',
    description: 'Identity systems that define and differentiate',
    icon: 'Sparkles'
  },
  {
    id: 6,
    title: 'UI & Digital Design',
    description: 'User experiences that delight and perform',
    icon: 'Monitor'
  }
];

export const stats = [
  { number: '50+', label: 'Projects Delivered' },
  { number: '30+', label: 'Clients Served' },
  { number: '6', label: 'Industries' },
  { number: '100%', label: 'Client Satisfaction' }
];

export const portfolioProjects = {
  graphicDesign: [
    {
      id: 1,
      title: 'Luxury Real Estate Branding',
      category: 'Graphic Design',
      description: 'Complete brand identity for premium property developers',
      image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5',
      tags: ['Branding', 'Print Design', 'Real Estate']
    },
    {
      id: 2,
      title: 'Restaurant Brand Identity',
      category: 'Graphic Design',
      description: 'Modern visual identity for upscale dining experience',
      image: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea',
      tags: ['Logo Design', 'Branding', 'Hospitality']
    },
    {
      id: 3,
      title: 'Corporate Visual System',
      category: 'Graphic Design',
      description: 'Professional brand guidelines for tech startup',
      image: 'https://images.unsplash.com/photo-1558655146-d09347e92766',
      tags: ['Corporate', 'Brand Guidelines', 'Startup']
    },
    {
      id: 4,
      title: 'Automotive Campaign Design',
      category: 'Graphic Design',
      description: 'High-impact marketing materials for luxury vehicles',
      image: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e',
      tags: ['Campaign', 'Automotive', 'Marketing']
    }
  ],
  videoEditing: [
    {
      id: 5,
      title: 'Construction Progress Documentary',
      category: 'Video Editing',
      description: 'Time-lapse storytelling for major infrastructure project',
      image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5',
      tags: ['Documentary', 'Construction', 'Time-lapse']
    },
    {
      id: 6,
      title: 'Gym Transformation Series',
      category: 'Video Editing',
      description: 'Motivational video content for fitness brand',
      image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48',
      tags: ['Fitness', 'Social Media', 'Brand Content']
    },
    {
      id: 7,
      title: 'Interior Design Showcase',
      category: 'Video Editing',
      description: 'Elegant video tour of luxury residential spaces',
      image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6',
      tags: ['Interior Design', 'Real Estate', 'Luxury']
    },
    {
      id: 8,
      title: 'Automotive Commercial',
      category: 'Video Editing',
      description: 'High-octane promotional video for new vehicle launch',
      image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7',
      tags: ['Commercial', 'Automotive', 'Launch']
    }
  ],
  uiUxDesign: [
    {
      id: 9,
      title: 'Real Estate Platform',
      category: 'UI/UX Design',
      description: 'Property search and listing mobile application',
      image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c',
      tags: ['Mobile App', 'Real Estate', 'UX']
    },
    {
      id: 10,
      title: 'Restaurant Ordering System',
      category: 'UI/UX Design',
      description: 'Seamless digital dining experience platform',
      image: 'https://images.unsplash.com/photo-1559028012-481c04fa702d',
      tags: ['Web App', 'Hospitality', 'E-commerce']
    },
    {
      id: 11,
      title: 'Corporate Dashboard',
      category: 'UI/UX Design',
      description: 'Data visualization and analytics interface',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
      tags: ['Dashboard', 'Analytics', 'Enterprise']
    },
    {
      id: 12,
      title: 'Fitness App Design',
      category: 'UI/UX Design',
      description: 'Workout tracking and community platform',
      image: 'https://images.unsplash.com/photo-1461773518188-b3e86f98242f',
      tags: ['Mobile App', 'Fitness', 'Social']
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'CEO, Prime Properties',
    company: 'Real Estate',
    content: 'Vintive Studio transformed our brand identity completely. Their attention to detail and creative vision exceeded our expectations.',
    rating: 5
  },
  {
    id: 2,
    name: 'James Rodriguez',
    role: 'Marketing Director',
    company: 'AutoLux Motors',
    content: 'The video campaign they created for our vehicle launch was absolutely stunning. Professional, creative, and delivered on time.',
    rating: 5
  },
  {
    id: 3,
    name: 'Emily Chen',
    role: 'Founder',
    company: 'Urban Eats Restaurant',
    content: 'From branding to digital presence, Vintive Studio delivered excellence at every touchpoint. Highly recommended!',
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'The Future of Video Marketing in 2025',
    excerpt: 'Explore emerging trends in video content and how brands can leverage visual storytelling to connect with audiences.',
    category: 'Video Marketing',
    image: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb',
    date: '2025-01-15',
    readTime: '5 min read'
  },
  {
    id: 2,
    title: 'Creating Brand Identity That Lasts',
    excerpt: 'A deep dive into the principles of timeless branding and how to create visual identities that stand the test of time.',
    category: 'Branding',
    image: 'https://images.unsplash.com/photo-1558655146-9f40138edfeb',
    date: '2025-01-10',
    readTime: '7 min read'
  },
  {
    id: 3,
    title: 'Behind the Scenes: Our Filmmaking Process',
    excerpt: 'Take a look at how we bring creative visions to life, from concept development to final delivery.',
    category: 'Filmmaking',
    image: 'https://images.unsplash.com/photo-1579017331263-ef82f0bbc748',
    date: '2025-01-05',
    readTime: '6 min read'
  },
  {
    id: 4,
    title: 'Motion Graphics: Elevating Your Brand Story',
    excerpt: 'Discover how motion graphics can transform your brand messaging and create unforgettable visual experiences.',
    category: 'Motion Graphics',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    date: '2024-12-28',
    readTime: '6 min read'
  }
];

export const serviceDetails = {
  filmmaking: {
    id: 'filmmaking',
    title: 'Filmmaking',
    tagline: 'Cinematic storytelling that captures your brand essence',
    image: 'https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e',
    description: 'Our filmmaking services combine artistic vision with technical excellence to create compelling visual narratives that resonate with your audience. From concept to final cut, we handle every aspect of production with meticulous attention to detail.',
    features: [
      { title: 'Commercial Production', description: 'High-impact commercials that drive results and capture attention' },
      { title: 'Corporate Videos', description: 'Professional videos that communicate your message effectively' },
      { title: 'Documentary Filmmaking', description: 'Authentic storytelling that connects emotionally with viewers' },
      { title: 'Event Coverage', description: 'Comprehensive coverage of your important moments' }
    ],
    process: [
      { title: 'Pre-Production', description: 'Concept development, scriptwriting, storyboarding, and planning' },
      { title: 'Production', description: 'Professional filming with cinema-grade equipment and experienced crew' },
      { title: 'Post-Production', description: 'Editing, color grading, sound design, and final delivery' },
      { title: 'Distribution', description: 'Format optimization and delivery across all platforms' }
    ]
  },
  'video-editing': {
    id: 'video-editing',
    title: 'Video Editing',
    tagline: 'Professional post-production that brings your vision to life',
    image: 'https://images.unsplash.com/photo-1574717025058-2f8737d2e2b7',
    description: 'Transform raw footage into polished, professional content with our expert video editing services. We use industry-leading software and techniques to deliver high-quality results that exceed expectations.',
    features: [
      { title: 'Color Grading', description: 'Professional color correction and grading for cinematic look' },
      { title: 'Sound Design', description: 'Audio mixing, enhancement, and synchronization' },
      { title: 'Motion Graphics', description: 'Dynamic text, titles, and graphic overlays' },
      { title: 'Multi-Camera Editing', description: 'Seamless editing of multi-angle footage' }
    ],
    process: [
      { title: 'Footage Review', description: 'Analyzing and organizing all raw footage' },
      { title: 'Assembly Edit', description: 'Creating the initial sequence and structure' },
      { title: 'Fine Cut', description: 'Refining timing, transitions, and pacing' },
      { title: 'Final Polish', description: 'Color grading, audio mixing, and export' }
    ]
  },
  'motion-graphics': {
    id: 'motion-graphics',
    title: 'Motion Graphics',
    tagline: 'Dynamic animations that engage and inspire',
    image: 'https://images.unsplash.com/photo-1628494391268-c9935bc384d5',
    description: 'Bring your ideas to life with stunning motion graphics that captivate audiences and communicate complex concepts with clarity and style.',
    features: [
      { title: '2D Animation', description: 'Engaging 2D animations for explainers and presentations' },
      { title: '3D Animation', description: 'Immersive 3D graphics and product visualizations' },
      { title: 'Logo Animation', description: 'Bring your brand logo to life with dynamic animations' },
      { title: 'Infographics', description: 'Data visualization and animated infographics' }
    ],
    process: [
      { title: 'Concept Design', description: 'Developing the visual concept and style frames' },
      { title: 'Storyboarding', description: 'Planning animation sequences and timing' },
      { title: 'Animation', description: 'Creating smooth, professional animations' },
      { title: 'Integration', description: 'Compositing and finalizing with sound' }
    ]
  },
  'graphic-design': {
    id: 'graphic-design',
    title: 'Graphic Design',
    tagline: 'Visual designs that communicate and convert',
    image: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea',
    description: 'Create impactful visual communications with our comprehensive graphic design services. From print to digital, we deliver designs that capture attention and drive results.',
    features: [
      { title: 'Marketing Materials', description: 'Brochures, flyers, posters, and promotional materials' },
      { title: 'Digital Graphics', description: 'Social media graphics, banners, and web assets' },
      { title: 'Print Design', description: 'Business cards, catalogs, and packaging design' },
      { title: 'Presentation Design', description: 'Professional pitch decks and presentations' }
    ],
    process: [
      { title: 'Discovery', description: 'Understanding your brand, audience, and objectives' },
      { title: 'Concept Development', description: 'Creating initial design concepts and directions' },
      { title: 'Design Refinement', description: 'Iterating based on feedback and preferences' },
      { title: 'Final Delivery', description: 'Providing print-ready and digital-ready files' }
    ]
  },
  'branding': {
    id: 'branding',
    title: 'Logo & Branding',
    tagline: 'Identity systems that define and differentiate',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5',
    description: 'Build a strong, memorable brand identity that resonates with your target audience. Our branding services create cohesive visual systems that stand the test of time.',
    features: [
      { title: 'Logo Design', description: 'Unique, memorable logos that represent your brand' },
      { title: 'Brand Guidelines', description: 'Comprehensive style guides for consistent branding' },
      { title: 'Visual Identity', description: 'Complete identity systems including colors and typography' },
      { title: 'Rebranding', description: 'Refresh and modernize existing brand identities' }
    ],
    process: [
      { title: 'Research', description: 'Market analysis, competitor research, and positioning' },
      { title: 'Strategy', description: 'Defining brand values, personality, and messaging' },
      { title: 'Design', description: 'Creating logo concepts and identity elements' },
      { title: 'Implementation', description: 'Brand guidelines and asset delivery' }
    ]
  },
  'ui-ux': {
    id: 'ui-ux',
    title: 'UI & Digital Design',
    tagline: 'User experiences that delight and perform',
    image: 'https://images.unsplash.com/photo-1586717799252-bd134ad00e26',
    description: 'Design digital experiences that users love. Our UI/UX services combine aesthetics with functionality to create intuitive, engaging interfaces.',
    features: [
      { title: 'Website Design', description: 'Responsive, user-friendly website designs' },
      { title: 'App Design', description: 'Mobile and web application interfaces' },
      { title: 'User Research', description: 'Understanding user needs and behaviors' },
      { title: 'Prototyping', description: 'Interactive prototypes for testing and validation' }
    ],
    process: [
      { title: 'Research & Analysis', description: 'User research, competitive analysis, and requirements' },
      { title: 'Wireframing', description: 'Creating low-fidelity layouts and user flows' },
      { title: 'Visual Design', description: 'High-fidelity mockups and design systems' },
      { title: 'Testing & Iteration', description: 'User testing and design refinements' }
    ]
  }
};
